<template>
    <div>
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick" style="background-color: white">
            <el-tab-pane label="C# 示例" name="first">
                <mavon-editor
                        v-model="content"
                        ref="md"
                        @change="change"
                        class="deitor"
                        :toolbars="markdownOption"
                        :subfield="false"
                        defaultOpen="preview"
                />
            </el-tab-pane>
            <el-tab-pane label="Java 示例" name="second">
                <mavon-editor
                        v-model="content2"
                        ref="md"
                        @change="change"
                        class="deitor"
                        :toolbars="markdownOption"
                        :subfield="false"
                        defaultOpen="preview"
                />

            </el-tab-pane>
        </el-tabs></div>
</template>

<script>
    // 导入组件 及 组件样式

    import uploadimg from '../../components/UploadImg'
    import changeAddress from '../../components/Address'

    export default {
        name: "Add",
        components: {
            uploadimg,
            changeAddress,
        },

        data() {
            return {
                activeName: 'first',
                markdownOption:{

                    toolbarsBackground:'#ff2200',
                    editable:false,
                    subfield:false,
                },
                content2:"## 获取设备历史数据接口 (单次获取时间范围最大一周)\n" +
                    "\n" +
                    "**简要描述：**\n" +
                    "\n" +
                    "- 根据设备SN编号获取设备历史数据\n" +
                    "\n" +
                    "**请求URL：**\n" +
                    "\n" +
                    "- `https://openapi.hzjly.cn/api/Monitor/GetDevData?devSN={devSN}&startTime={startTime}&endTime={endTime}`\n" +
                    "\n" +
                    "**请求方式：**\n" +
                    "\n" +
                    "- Get\n" +
                    "\n" +
                    "**请求参数：**\n" +
                    "\n" +
                    "| 参数名    | 必选 | 类型   | 说明       |\n" +
                    "| :-------- | :--- | :----- | ---------- |\n" +
                    "| devSN     | 是   | string | 设备SN编号 |\n" +
                    "| startTime | 是   | string | 开始时间(包含)|\n" +
                    "| endTime   | 是   | string | 结束时间(包含)|\n" +
                    "\n" +
                    "**回文参数：**\n" +
                    "\n" +
                    "| 参数    | 类型   | 描述       |\n" +
                    "| :------ | :----- | :--------- |\n" +
                    "| SN      | string | 设备SN     |\n" +
                    "| devName | string | 设备名称   |\n" +
                    "| devTime | string | 设备时间   |\n" +
                    "| lat     | number | 纬度       |\n" +
                    "| lon     | number | 经度       |\n" +
                    "| value   | string | 通道值     |\n" +
                    "| port    | number | 通道端口号 |\n" +
                    "| isover  | number | 是否超标   |\n" +
                    "| name    | string | 通道名称   |\n" +
                    "| unit    | string | 通道单位   |\n" +
                    "\n" +
                    "**接口响应参数：**\n" +
                    "\n" +
                    "| 参数 | 类型   | 描述                                           |\n" +
                    "| :--- | :----- | :--------------------------------------------- |\n" +
                    "| code | number | 101：身份验证失败 200：请求成功，500：接口异常 |\n" +
                    "| data | string | 数据json                                       |\n" +
                    "| msg  | string | 提示信息                                       |\n" +
                    "\n" +
                    "## 请求示例\n" +
                    "\n" +
                    "```\n" +
                    "public static String GetDateInfo()\n" +
                    "{\n" +
                    "    String devSN = \"190300495\";\n" +
                    "    String startTime = \"2021-05-16 00:00:00\";\n" +
                    "    String endTime = \"2021-05-17 00:00:00\";\n" +
                    "\n" +
                    "    String url = \"https://openapi.hzjly.cn/api/Monitor/GetDevData?devSN=\" + devSN + \"&startTime=\" + startTime + \"&endTime=\" + endTime + \"\";\n" +
                    "\n" +
                    "    //用户名以及密钥申请请联系管理员\n" +
                    "    String secret = \"93f115318cd68d7c0c6720352a72b022\";\n" +
                    "    String username = \"openApiTest\";\n" +
                    "\n" +
                    "    //获取GMT时间 详情请见获取GMT时间实例\n" +
                    "    String date = GetGMTTime();\n" +
                    "\n" +
                    "    //获取签名 详情请见签名获取方式\n" +
                    "    String signature = GetSignature(secret, username, date);\n" +
                    "\n" +
                    "    //身份验证信息拼接\n" +
                    "    String authorization = \"{\\\"UserName\\\":\\\"\" + username + \"\\\",\\\"Date\\\":\\\"\" + date + \"\\\",\\\"Signature\\\":\\\"\" + signature + \"\\\"}\";\n" +
            "\n" +
            "    //发送GET请求 详情请见GET请求实例\n" +
            "\n" +
            "    String result = CreateGetHttpResponse(url, authorization);\n" +
            "    return result;\n" +
            "}\n" +
            "```\n" +
            "\n" +
            "## 返回示例\n" +
            "\n" +
            "```\n" +
            "{\n" +
            "   \"code\": 200,\n" +
            "   \"data\": [{\n" +
            "           \"SN\": \"190300495\",\n" +
            "           \"devName\": \"190300495\",\n" +
            "           \"devTime\": \"2021/5/17 15:00:00\",\n" +
            "           \"lat\": 0,\n" +
            "           \"lon\": 0,\n" +
            "           \"channelList\": [\n" +
            "               {\n" +
            "                   \"value\": \"-10000\",\n" +
            "                   \"port\": 1,\n" +
            "                   \"isover\": 1,\n" +
            "                   \"name\": \"通道1\",\n" +
            "                   \"unit\": \"℃\"\n" +
            "               },\n" +
            "               {\n" +
            "                   \"value\": \"-10000\",\n" +
            "                   \"port\": 2,\n" +
            "                   \"isover\": 1,\n" +
            "                   \"name\": \"通道2\",\n" +
            "                   \"unit\": \"%RH\"\n" +
            "               },\n" +
            "               {\n" +
            "                   \"value\": \"-10000\",\n" +
            "                   \"port\": 3,\n" +
            "                   \"isover\": 1,\n" +
            "                   \"name\": \"通道3\",\n" +
            "                   \"unit\": \"℃\"\n" +
            "               }\n" +
            "           ]\n" +
            "       }],\n" +
            "   \"msg\": \"\"\n" +
            "}\n" +
            "```\n" +
            "\n" +
            "## **备注** 如果返回信息为：Authentication exception 说明身份验证失败",
                content:"## 获取设备历史数据接口 (单次获取时间范围最大一周)\n" +
                    "**简要描述：** \n" +
                    "\n" +
                    "- 根据设备SN编号获取设备历史数据\n" +
                    "\n" +
                    "**请求URL：** \n" +
                    "      \n" +
                    "\n" +
                    "- `https://openapi.hzjly.cn/api/Monitor/GetDevData?devSN={devSN}&startTime={startTime}&endTime={endTime}`\n" +
                    "\n" +
                    "**请求方式：**\n" +
                    "\n" +
                    "- Get \n" +
                    "\n" +
                    "\n" +
                    "**请求参数：** \n" +
                    "\n" +
                    "|参数名|必选|类型|说明|\n" +
                    "|:----    |:---|:----- |-----   |\n" +
                    "| devSN| 是 | string | 设备SN编号 |\n" +
                    "| startTime| 是 | string | 开始时间(包含)|\n" +
                    "| endTime| 是 | string | 结束时间(包含)|\n" +
                    "\n" +
                    "**回文参数：** \n" +
                    "|参数|类型|描述|\n" +
                    "|:-------|:-------|:-------|\n" +
                    "| SN| string| 设备SN|\n" +
                    "| devName| string| 设备名称 |\n" +
                    "| devTime| string| 设备时间 |\n" +
                    "| lat| number| 纬度 |\n" +
                    "| lon| number| 经度 |\n" +
                    "| value| string| 通道值 |\n" +
                    "| port| number| 通道端口号 |\n" +
                    "| isover| number| 是否超标 |\n" +
                    "| name| string| 通道名称 |\n" +
                    "| unit| string| 通道单位 |\n" +
                    "\n" +
                    "**接口响应参数：** \n" +
                    " |参数|类型|描述|\n" +
                    "|:-------|:-------|:-------|\n" +
                    "| code| number| 101：身份验证失败 200：请求成功，500：接口异常|\n" +
                    "| data| string| 数据json |\n" +
                    "| msg|string | 提示信息 |\n" +
                    "\n" +
                    "##  请求示例\n" +
                    "        public static string GetDateInfo()\n" +
                    "        {\n" +
                    "            string devSN = \"190300495\";\n" +
                    "            string startTime = \"2025-04-16 00:00:00\";\n" +
                    "            string endTime = \"2025-04-17 00:00:00\";\n" +
                    "\n" +
                    "            string url = \"https://openapi.hzjly.cn/api/Monitor/GetDevData?devSN=\" + devSN + \"&startTime=\" + startTime + \"&endTime=\" + endTime + \"\";\n" +
                    "\n" +
                    "           //用户名以及密钥申请请联系管理员\n" +
                    "            string secret = \"93f115318cd68d7c0c6720352a72b022\";\n" +
                    "            string username = \"openApiTest\";\n" +
                    "\n" +
                    "            //获取GMT时间 详情请见获取GMT时间实例\n" +
                    "            string date = GetGMTTime(DateTime.Now);\n" +
                    "\n" +
                    "            //获取签名 详情请见签名获取方式\n" +
                    "            string signature = GetSignature(secret, username, date);\n" +
                    "\n" +
                    "            //身份验证信息拼接\n" +
                    "            string authorization = \"{\\\"UserName\\\":\\\"\" + username + \"\\\",\\\"Date\\\":\\\"\" + date + \"\\\",\\\"Signature\\\":\\\"\" + signature + \"\\\"}\";\n" +
                    "\n" +
                    "            //发送GET请求 详情请见GET请求实例\n" +
                    "            string result = CreateGetHttpResponse(url, authorization);\n" +
                    "            return result;\n" +
                    "        }\n" +
                    "\n" +
                    "\n" +
                    "##  返回示例\n" +
                    "\n" +
                    " ``` \n" +
                    "{\n" +
                    "\t\"code\": 200,\n" +
                    "\t\"data\": [{\n" +
                    "            \"SN\": \"190300495\",\n" +
                    "            \"devName\": \"190300495\",\n" +
                    "            \"devTime\": \"2025/4/17 15:00:00\",\n" +
                    "            \"lat\": 0,\n" +
                    "            \"lon\": 0,\n" +
                    "            \"channelList\": [\n" +
                    "                {\n" +
                    "                    \"value\": \"-10000\",\n" +
                    "                    \"port\": 1,\n" +
                    "                    \"isover\": 1,\n" +
                    "                    \"name\": \"通道1\",\n" +
                    "                    \"unit\": \"℃\"\n" +
                    "                },\n" +
                    "                {\n" +
                    "                    \"value\": \"-10000\",\n" +
                    "                    \"port\": 2,\n" +
                    "                    \"isover\": 1,\n" +
                    "                    \"name\": \"通道2\",\n" +
                    "                    \"unit\": \"%RH\"\n" +
                    "                },\n" +
                    "                {\n" +
                    "                    \"value\": \"-10000\",\n" +
                    "                    \"port\": 3,\n" +
                    "                    \"isover\": 1,\n" +
                    "                    \"name\": \"通道3\",\n" +
                    "                    \"unit\": \"℃\"\n" +
                    "                }\n" +
                    "            ]\n" +
                    "        }],\n" +
                    "\t\"msg\": \"\"\n" +
                    "}\n" +
                    " ```\n" +
                    " \n" +
                    "\n" +
                    " **备注** \n" +
                    "如果返回信息为：Authentication exception\n" +
                    "说明身份验证失败\n" +
                    "----------", // 输入的markdown
                html:'',    // 及时转的html
            }
        },
        created() {
        },
        mounted() {

        },
        methods: {
            handleClick(tab, event) {
                console.log(tab, event);
            },
            // 所有操作都会被解析重新渲染
            change(value, render){
                // render 为 markdown 解析后的结果[html]
                this.html = render;
            },
            // 提交
            submit(){
                console.log(this.content);
                console.log(this.html);
            }
        },

    };
</script>
<style scoped>
    @import "../../assets/css/normal.css";
.title-font{
    line-height: 40px;
    font-size: 16px;
    color: #4ba2f9;
    padding-right: 12px;
    width:248px;
    text-align: right;
    margin-left: 20px;
}

</style>
